export const createTest = `
mutation createTest ($input: TestUpsert!) {
    createTest (input: $input) {
        id
        createdAt
        updatedAt
}}
`;
